export class GiftCardBalanceTransferRequestDto {
  fromCardId: number;
  toCardId: number;
  amount: number;
  giftCardReasonId: number;
}
